import { useCallback, useEffect, useState } from "react"
import { useIntl } from "react-intl"

import { maxStringLength } from '../../../api/additionalInformation'

export const isString = (item: string | undefined): item is string => {
  return !!item
}

const useValidateStringLength = () => {
  const intl = useIntl()

  return (fieldName: string, [min, max]: [number, number], messageId?: string) => ({
    regexp: new RegExp(`^.{${min},${max}}$`),
    message: messageId ? intl.formatMessage({ id: messageId }) : intl.formatMessage({ id: 'validation.stringLength' }, { fieldName, min, max })
  })
}

export const useAdditionalStringValidators = () => {
  const intl = useIntl()
  const validateStringLength = useValidateStringLength()

  return (messageId: string, minLength = 0, maxLength = maxStringLength) => {
    const fieldName = intl.formatMessage({ id: messageId })
    return [validateStringLength(fieldName, [minLength, maxLength])]
  }
}

export const useSecondsCountdown = () => {
  const [countdown, setCountdown] = useState<number>(0)

  const startCountdown = useCallback((seconds: number) => {
    setCountdown(seconds)
  }, [])

  const stopCountdown = useCallback(() => {
    setCountdown(0)
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (countdown > 0) {
        setCountdown(countdown - 1)
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [countdown])

  return {
    countdown,
    startCountdown,
    stopCountdown
  }
}
